// 品牌
import React from 'react'
import defaultSetting from '@/setting'
import {getUrlParams} from "@/utils/util"
import styles from './index.module.scss'
import brandBanner_01 from '../../../assets/mobileImages/brand/brandBanner_01.jpg'
import brandBanner_02 from '../../../assets/mobileImages/brand/brandBanner_02.png'
import brandBanner_03 from '../../../assets/mobileImages/brand/brandBanner_03.jpg'
import brandBanner_04 from '../../../assets/mobileImages/brand/brandBanner_04.png'
import brandBanner_05 from '../../../assets/mobileImages/brand/brandBanner_05.jpg'
import brandBanner_06 from '../../../assets/mobileImages/brand/brandBanner_06.png'
import brandBanner_07 from '../../../assets/mobileImages/brand/brandBanner_07.png'
import brandBanner_08 from '../../../assets/mobileImages/brand/brandBanner_08.jpg'
import brandBanner_09 from '../../../assets/mobileImages/brand/brandBanner_09.jpg'
import brandBanner_10 from '../../../assets/mobileImages/brand/brandBanner_10.jpg'
import brandBanner_11 from '../../../assets/mobileImages/brand/brandBanner_11.jpg'
import brandBanner_12 from '../../../assets/mobileImages/brand/brandBanner_12.png'
import brandBanner_13 from '../../../assets/mobileImages/brand/brandBanner_13.jpg'
// import brandBanner_14 from '../../../assets/mobileImages/brand/brandBanner_14.png'
import brandBanner_15 from '../../../assets/mobileImages/brand/brandBanner_15.jpg'
// import brandBanner_16 from '../../../assets/mobileImages/brand/brandBanner_16.png'
import brandBanner_17 from '../../../assets/mobileImages/brand/brandBanner_17.jpg'
import brandBanner_18 from '../../../assets/mobileImages/brand/brandBanner_18.png'
// import brandBanner_19 from '../../../assets/mobileImages/brand/brandBanner_19.png'
// import brandBanner_20 from '../../../assets/mobileImages/brand/brandBanner_20.png'
import brandBanner_21 from '../../../assets/mobileImages/brand/brandBanner_21.jpg'
import brandBanner_22 from '../../../assets/mobileImages/brand/brandBanner_22.jpg'
import brandBanner_23 from '../../../assets/mobileImages/brand/brandBanner_23.jpg'
import brandBanner_24 from '../../../assets/mobileImages/brand/brandBanner_24.jpg'
import brandBanner_25 from '../../../assets/mobileImages/brand/brandBanner_25.png'
import {getPositionsNumlApi} from "../../../api";

class MobileBrand extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            bannerImg:[
                {
                    imgUrl: brandBanner_01,
                    toUrl: `?orgCode=0/255`,
                    title: "一汽红旗",
                    content: ' 个在招职位'
                },
                {
                    imgUrl: brandBanner_22,
                    toUrl: `?orgCode=0/83`,
                    title: "一汽红旗(研发总院)",
                    content: ' 个在招职位'
                },
                {
                    imgUrl: brandBanner_02,
                    toUrl: `?orgCode=0/266`,
                    title: "一汽解放",
                    content: ' 个在招职位'
                },
                {
                    imgUrl: brandBanner_03,
                    toUrl: `?orgCode=0/270`,
                    title: "一汽奔腾",
                    content: ' 个在招职位'
                },
                {
                    imgUrl: brandBanner_04,
                    toUrl: `?orgCode=0/258`,
                    title: "一汽-大众",
                    content: ' 个在招职位'
                },
                {
                    imgUrl: brandBanner_05,
                    toUrl: `?orgCode=0/28`,
                    title: "一汽丰田",
                    content: ' 个在招职位'
                },
                {
                    imgUrl: brandBanner_10,
                    toUrl: `?orgCode=0/269`,
                    title: "一汽资本控股",
                    content: ' 个在招职位'
                },
                {
                    imgUrl: brandBanner_24,
                    toUrl: `?orgCode=0/260501`,
                    title: "财务公司",
                    content: ' 个在招职位'
                },
                {
                    imgUrl: brandBanner_21,
                    toUrl: `?orgCode=0/2393`,
                    title: "一汽股权",
                    content: ' 个在招职位'
                },
                {
                    imgUrl: brandBanner_13,
                    toUrl: `?orgCode=0/259`,
                    title: "一汽进出口",
                    content: ' 个在招职位'
                },
                {
                    imgUrl: brandBanner_12,
                    toUrl: `?orgCode=0/271`,
                    title: "一汽出行",
                    content: ' 个在招职位'
                },
                {
                    imgUrl: brandBanner_09,
                    toUrl: `?orgCode=0/267`,
                    title: "一汽模具",
                    content: ' 个在招职位'
                },
                {
                    imgUrl: brandBanner_15,
                    toUrl: `?orgCode=0/257`,
                    title: "一汽富华",
                    content: ' 个在招职位'
                },
                {
                    imgUrl: brandBanner_08,
                    toUrl: `?orgCode=0/262`,
                    title: "一汽铸锻",
                    content: ' 个在招职位'
                },
                // {
                //     imgUrl: brandBanner_07,
                //     toUrl: `?orgCode=0/264`,
                //     title: "一汽物流",
                //     content: ' 个在招职位'
                // },
                {
                    imgUrl: brandBanner_23,
                    toUrl: `?orgCode=0/259601`,
                    title: "中汽新能",
                    content: ' 个在招职位'
                },
                {
                    imgUrl: brandBanner_11,
                    toUrl: `?orgCode=0/265`,
                    title: "启明信息",
                    content: ' 个在招职位'
                },
                // {
                //     imgUrl: brandBanner_18,
                //     toUrl: `?orgCode=0/254`,
                //     title: "长春检测中心",
                //     content: ' 个在招职位'
                // },
                {
                    imgUrl: brandBanner_17,
                    toUrl: `?orgCode=0/268`,
                    title: "能源公司",
                    content: ' 个在招职位'
                },
                {
                    imgUrl: brandBanner_25,
                    toUrl: `?orgCode=0/261401`,
                    title: "旗新动力",
                    content: ' 个在招职位'
                },
                {
                    imgUrl: brandBanner_06,
                    // toUrl: `?orgCode=0/261`,
                    toUrl: ``,
                    specialSuiteKey: `SU6614b5d61c240e60b648b146`,
                    title: "奥迪一汽",
                    content: ' 个在招职位'
                },
                // {
                //     imgUrl: brandBanner_14,
                //     toUrl: `?orgCode=0/263`,
                //     title: "一汽旗偲",
                //     content: ' 个在招职位'
                // },
                // {
                //     imgUrl: brandBanner_16,
                //     toUrl: `?orgCode=0/41`,
                //     title: "一汽资产",
                //     content: ' 个在招职位'
                // },
                // {
                //     imgUrl: brandBanner_19,
                //     toUrl: `?orgCode=0/242`,
                //     title: "华东试验场",
                //     content: ' 个在招职位'
                // },
                // {
                //     imgUrl: brandBanner_20,
                //     toUrl: `?orgCode=0/260`,
                //     title: "机械九院",
                //     content: ' 个在招职位'
                // },
            ],
            positionsCode: [
                '0/255', '0/83', '0/266', '0/270', '0/258',
                '0/28', '0/269', '0/260501', '0/2393', '0/259', '0/271',
                '0/267', '0/257', '0/262', '0/259601',
                '0/265', '0/268', '0/261401', '0/261',

            ],
            positionsNum: [],
        }
    }


    componentDidMount() {
        const {recruitType} = getUrlParams();

        getPositionsNumlApi({recruitType: recruitType, curSearchEle: 'org'}).then(res => {
            let {positionsCode, positionsNum} = this.state;
            const {orgList} = res.data;

            for (let i = 0; i < positionsCode.length; i++) {
                for (let j = 0; j < orgList.length; j++) {
                    if (positionsCode[i] === orgList[j].code) {
                        positionsNum[i] = orgList[j].positionsNum;
                    }
                }
            }

            this.setState({
                positionsNum
            })
        })

        // 隐藏页面底部文字
        document.querySelector('.footer').style.display = 'none';
    }

    render() {
        const {bannerImg,positionsNum} = this.state;
        const {recruitType} = getUrlParams();
        return (
            <>
                <main className={styles.mobileBrand}>
                    <div className="brandCon">
                    {
                        bannerImg&&bannerImg.map((item,index)=>{
                            const {specialSuiteKey} = item;
                            let hrefUrl = `/${defaultSetting.suiteKeyMc}/mc/position/${recruitType === '1' ? 'campus' : 'society'}${item.toUrl}`;

                            if (specialSuiteKey) {
                                hrefUrl = `/${specialSuiteKey}/mc/position/${recruitType === '1' ? 'campus' : 'society'}${item.toUrl}`;
                            }

                            return (
                                <a className={styles.bannerBox} key={index} href={hrefUrl}>
                                    <img src={item.imgUrl} className={styles.bannerImg} />
                                    <div className={styles.bannerCon}>
                                        <div className={styles.bannerTitle}>{item.title}</div>
                                        <div className={styles.bannerSunTitle}>
                                            {positionsNum[index] || 0}{item.content}
                                        </div>
                                    </div>
                                </a>
                            )
                        })
                    }
                    </div>
                </main>
            </>
        );
    }
  }

  export default MobileBrand;